export const unspecifiedWarehouseLocation = '(Unspecified)';
